import type { TMessages } from '@/types/TMessages'

export const messages = {
  steps: {
    title: 'Этапы получения средств',
    '1': 'Выбор техники / оборудования у поставщика',
    '2': 'Оформление заявки на поле.рф',
    '3': 'Одобрение заявки и согласование условий',
    '4': 'Заключение договора',
    '5': 'Получение техники /<br/>оборудования',
    button: 'Подать заявку',
  },
  affiliation: {
    description:
      '<ul class="list-with-marks"><li>Производители сельскохозяйственной продукции*</li><li>ИП и Юридические лица, осуществляющие деятельность<br/>в смежных отраслях (транспортировка, переработка сельхозпродукции, производство и реализация пищевых продуктов и т.д.)</li><li>Прочие юридические лица и ИП, отвечающие требованиям «Альфа-Лизинга»</li></ul>',
    requirements: {
      text: '<ul class="list-with-marks"><li>Срок деятельности от 6 месяцев (либо понадобится поручитель);</li><li>Региональные ограничения: Республика Дагестан, Республика Ингушетия, Чеченская Республика, Республика Адыгея, Карачаево-Черкесская Республика, Кабардино-Балкарская Республика, Республика Северная Осетия-Алания</li></ul>',
      alert:
        'Вы можете стать лизингополучателем, если у вас отсутствует просроченная задолженность по налогам, сборам, взносам, обязательным платежам и кредитам в финансовых организациях',
    },
    law: '* В соответствии с Федеральным законом от 29.12.2006 № 264-ФЗ (ред. 25.12.2018) «О развитии сельского хозяйства»',
  },
  header: {
    title: 'Лизинг новой и б/у\nсельхозтехники и оборудования, автотранспорта',
    description:
      'Лизинг российской и белорусской техники с субсидиями от государства, сезонный график платежей под запрос бизнеса, эксклюзивные скидки',
  },
  benefits: {
    description: {
      first: 'Оценка клиента и принятие решения проходят за 1 день',
      second: 'Аванс составляет от 0% до 49% и зависит от пожеланий Клиента, техники и программы финансирования',
      third: 'Финансовая гарантия - погашение долга по лизингу при угоне / тотале',
    },
    banner: {
      title: 'Развивайте бизнес на своих условиях!',
      benefits: {
        machines: 'Сезонный график платежей в зависимости от загрузки вашего бизнеса',
        accreditation: 'Субсидии от регионов РФ, от Минпромторга РФ и МинФина РБ',
        machineAge: 'Вся бюрократия по оформлению господдержки на стороне Альфа-Лизинга',
        conditions: 'Ответ о получении субсидии по почте в течение 3 дней',
      },
    },
  },
  form: { title: 'Оставьте заявку на лизинг от «Альфа-Лизинг» уже сейчас!' },
  financingOffer: {
    hint: {
      forAgrariansOnly: 'Доступно только для аграриев',
    },
    details: {
      advancePayment: {
        value: "от <span class='h2 h3-sm with-counter-animation' data-value='0'>0%</span>",
        sign: 'аванс',
      },
      amountOfLeasing: {
        value: "до <span class='h2 h3-sm with-counter-animation' data-value='500'>0</span>млн ₽",
        sign: 'финансирование',
      },
      preliminaryDecision: {
        value: "до <span class='h2 h3-sm with-counter-animation' data-value='24'>0</span> часов",
        sign: 'срок одобрения',
      },
      deadline: {
        value: "до <span class='h2 h3-sm with-counter-animation' data-value='5'>0</span> лет",
        sign: 'срок лизинга',
      },
      discount: {
        value: "до <span class='h2 h3-sm with-counter-animation' data-value='20'>0%</span>",
        sign: 'скидка',
      },
    },
  },
  leaveRequest: 'Подать заявку',
  breadcrumb: 'Альфа-Лизинг',
} satisfies TMessages
